import React from 'react'

const CanSendContext = React.createContext(null)

const CanSendProvider = ({ children }) => {
  const [canSend, setCanSend] = React.useState(true)

  return (
    <CanSendContext.Provider value={{ canSend, setCanSend }}>
      {children}
    </CanSendContext.Provider>
  )
}

export default CanSendProvider

export const useCanSend = () => React.useContext(CanSendContext)
